import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { OrganizationModel } from '@app/data-layer/models/organizations/organization-model';
import { AppLayoutService } from '@app/modules/app-layout/app-layout.service';
import { IHeaderItem } from '@app/modules/app-layout/interfaces';
import { GenericService } from '@services/generic.service';
import { OrganizationsService } from '@services/organizations.service';
import { Observable, ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'account-settings-organization-details',
  templateUrl: './account-settings-organization-details.component.html',
  styleUrls: ['./account-settings-organization-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountSettingsOrganizationDetailsComponent implements OnInit {
  public formGroup: UntypedFormGroup;
  public organization: OrganizationModel;
  public isTablet: boolean;

  private destroy$: ReplaySubject<void> = new ReplaySubject<void>();

  constructor(
    private organizationsService: OrganizationsService,
    private appLayoutService: AppLayoutService,
    private genericService: GenericService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.genericService.isTablet$.pipe(takeUntil(this.destroy$)).subscribe((state: boolean) => {
      this.isTablet = state;
    });
    this.createForm();
  }

  private createForm(isUpdateHeader: boolean = true): void {
    this.getOrganization()
      .pipe(takeUntil(this.destroy$))
      .subscribe((organization: OrganizationModel) => {
        //TODO: remove company varialbe,setting default company and logic after new bonds
        this.organization = organization;
        this.organizationsService.setDefaultOrganization(this.organization);

        this.formGroup = this.organizationsService.createOrganizationForm(organization);
        if (isUpdateHeader) {
          this.updateDashboardHeader(organization.businessName);
        }
        this.cdr.markForCheck();
      });
  }

  private getOrganization(): Observable<OrganizationModel> {
    return this.organizationsService.getOrganizationByIdFromServer(this.route.snapshot.params.id);
  }

  private updateDashboardHeader(businessName: string): void {
    const title: IHeaderItem[] = [];
    if (this.isTablet) {
      title.push(
        {
          key: 'MENU.ACCOUNT_SETTINGS',
          link: '/companies/account-settings',
        },
        {
          key: 'LABELS.ORGANIZATION',
          link: null,
        },
      );
      this.appLayoutService.contentHeader$.next({ title, mobileTitle: title });
      return;
    }

    title.push({
      key: 'MENU.ACCOUNT_SETTINGS',
      link: '/companies/account-settings',
    });

    if (!!this.organization) {
      title.push(
        {
          key: 'LABELS.ORGANIZATION',
          link: '/companies/account-settings/organization',
        },
        {
          key: !!businessName ? businessName : 'LABELS.ORGANIZATION',
          link: null,
          params: {
            intranslatable: !!businessName,
          },
        },
      );
    }
    this.appLayoutService.contentHeader$.next({ title, mobileTitle: title });
  }
}
